




































































import { Component, Vue } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'
import InfiniteLoading from 'vue-infinite-loading'

import _get from 'lodash/get'

import { Book, Offer, OfferItem } from '@/types'
import { OffersState } from '@/store/offers/types'
import { stringToCurrency } from '@/utils/numeric.util'
import UploadInventoryList from '@/components/UploadInventoryList.vue'

const namespace: string = 'offers'

@Component({
  components: {
    InfiniteLoading,
    UploadInventoryList,
  },
  methods: {
    _get,
  },
})
export default class ReviewOfferPage extends Vue {
  @State('offers') private offersState: OffersState | undefined

  @Getter('getOffer', { namespace }) private offer: Offer | undefined

  @Action('getOffer', { namespace }) private getOffer: any
  @Action('getOfferItems', { namespace }) private getOfferItems: any
  @Action('postOfferProcess', { namespace }) private postOfferProcess: any

  private offerItems: OfferItem[] = []
  private totalNumberOfferItems: number = 0
  private infiniteId: number = new Date().getTime()
  private offset: number = 0
  private itemsPerPage: number = 10

  private routerProcess: any = null
  private requestGetOffer: boolean = false

  private mounted(): void {
    if (!this.$route.query.id) {
      return
    }

    this.routerProcess = Boolean(this.$route.query.process) || !this.$route.query.token

    this.requestGetOffer = true
    this.getOffer({ filter: { id: this.$route.query.id }, token: this.$route.query.token })
      .then(res => {
        if (!res) {
          Vue.$toast.error('There is no offer.')
        }

        if (this.$route.query.process) {
          this.postOfferProcess({
            id: this.$route.query.id,
            token: this.$route.query.token,
            offerProcessType: this.$route.query.process,
          })
            .then(res1 => {
              if (res1 === true) {
                if (this.$route.query.process === 'accept') {
                  Vue.$toast.success('Your offer has been approved.')
                } else {
                  Vue.$toast.error('Your offer has been rejected.')
                }
              } else if (res1.message) {
                Vue.$toast.error(res1.message)
              }
            })
            .catch(err => {})
            .finally(() => {
              this.requestGetOffer = false
              this.infiniteId += 1
            })
        } else {
          this.infiniteId += 1
        }
      })
      .catch(err => {})
      .finally(() => {
        if (!this.$route.query.process) {
          this.requestGetOffer = false
        }
      })

    this.$socket.client.on('InventoryList-Processing', data => {
      if (this.offer) {
        this.offset = 0
        this.infiniteId += 1
      }
    })
  }

  private destroyed(): void {}

  get offerState() {
    if (this.offerProcessed) return 'processed'
    return (
      _get(this.offer, ['offerRevisions', 0, 'offerRevisionStates', 0, 'revisionStateCode']) || ''
    )
  }

  get totalOfferPrice() {
    const totalPrice = _get(this.offer, ['offerTotal']) || ''
    return totalPrice ? `$${stringToCurrency(totalPrice)}` : '$0.00'
  }

  get processingOffer() {
    return _get(this.offersState, ['requestPostOfferRevise']) || false
  }

  get offerProcessed() {
    return _get(this.offersState, ['offerProcessed']) || false
  }

  private infiniteHandler($state) {
    if (!this.offer || !this.offer.id || this.requestGetOffer) {
      $state.loaded()
      $state.complete()
      return
    }

    this.getOfferItems({
      limit: this.itemsPerPage,
      offset: this.offset,
      order: [],
      offerId: this.offer!.id,
    })
      .then(res => {
        const temp = (_get(res, 'rows') || []).map(r => ({
          ...r,
          offerPrice: r.offerPrice || 0,
        })) // .toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")

        this.totalNumberOfferItems = _get(res, 'count') || 0
        this.offerItems = !this.offset ? temp : [...this.offerItems, ...temp]

        $state.loaded()
        if (this.offerItems.length >= this.totalNumberOfferItems) {
          $state.complete()
        }

        this.offset += temp.length || 0
        if (!temp.length && this.offset === 0) {
          Vue.$toast.error('No matches found.')
        }
      })
      .catch(err => {
        $state.loaded()
        $state.complete()
      })
      .finally(() => {})
  }

  private getQuantity(offerItem: OfferItem) {
    return _get(offerItem, ['quantity']) || 0
  }

  private getOfferItemPrice(offerItem: OfferItem) {
    const price = stringToCurrency(
      (_get(offerItem, ['offerPrice']) || 0) * this.getQuantity(offerItem)
    )
    return price ? `$${price}` : '$0.00'
  }

  private getBookOfferPrice(offerItem: OfferItem) {
    const price = stringToCurrency(_get(offerItem, ['offerPrice']))
    return price ? `$${price}` : ''
  }

  private onClickProcessOffer(offerProcessType: string) {
    this.postOfferProcess({ id: this.offer!.id, token: this.$route.query.token, offerProcessType })
      .then(() => {
        if (this.$route.query.process === 'accept') {
          Vue.$toast.success('Your offer has been approved.')
        } else {
          Vue.$toast.info('Your offer has been rejected.')
        }
      })
      .catch(err => {})
      .finally(() => {})
  }
}
